import { useLocation } from 'react-router-dom';

import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';
import { Button } from '@spacefill/uikit/src/components/Button';

export function CopyContextButton() {
    const { user } = useUserContext();
    const location = useLocation();

    const copyToClipboard = (additionalContext) => {
        navigator.clipboard.writeText(`
\`\`\`
${JSON.stringify({ user, location: { url: document.location.url, ...location }, env: import.meta.env, ...additionalContext, date: new Date() }, null, 2)}
\`\`\`
        `);
    };

    return (
        <Button
            variant='outlined'
            size='small'
            className='w-full'
            data-testid='copy-context-button'
            iconStart={<FontAwesomeIcon icon={faCopy} />}
            onClick={() => {
                fetch(`${__ROUTER_BASE_NAME__}version.json`)
                    .then((response) => {
                        return response.json();
                    })
                    .then((versionData) => {
                        copyToClipboard({ versionData });
                    })
                    .catch((err) => {
                        // eslint-disable-next-line no-console
                        console.warn('Failed to fetch version data:', err);
                        copyToClipboard({ versionData: { a: 1 } });
                    });
            }}
        >
            Copy context for debug
        </Button>
    );
}
